import { render, staticRenderFns } from "./UploadEVisualizacao.vue?vue&type=template&id=07f27430"
import script from "./UploadEVisualizacao.vue?vue&type=script&lang=js"
export * from "./UploadEVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./UploadEVisualizacao.vue?vue&type=style&index=0&id=07f27430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports